export const LATE_CANCEL_ERROR_CODES = {
  ackRequired: 'late_cancel_ack_required',
  blocked: 'late_cancel_blocked',
} as const

/** Set by the SMS policy reply link; it only opens the warning, the server still decides. */
export const LATE_CANCEL_QUERY_PARAM = 'late_cancel'

export const CONFIRMATION_DATE_FORMAT = 'iiii, MMMM d @ '
export const CONFIRMATION_TIME_FORMAT = 'h:mmaaa'
export const CONFIRMATION_DATE_TIME_FORMAT = `${CONFIRMATION_DATE_FORMAT}${CONFIRMATION_TIME_FORMAT}`
